(function (window, document) {
    'use strict';

    var returnStateKey = 'ikson-track-to-music-library-return';

    function isMusicLibraryPage() {
        return window.location.pathname === '/music';
    }

    function isModifiedNavigation(event) {
        return event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    }

    function getClosestReturnLink(element) {
        while (element && element !== document) {
            if (element.nodeType === 1 && element.hasAttribute('data-music-library-return')) {
                return element;
            }

            element = element.parentNode;
        }

        return null;
    }

    function setReturnState() {
        try {
            window.sessionStorage.setItem(returnStateKey, '1');
        } catch (error) {
            // Normal navigation remains the fallback when session storage is unavailable.
        }
    }

    function consumeReturnState() {
        var shouldSuppressAnimations = false;

        if (!isMusicLibraryPage()) {
            return false;
        }

        try {
            shouldSuppressAnimations = window.sessionStorage.getItem(returnStateKey) === '1';
            window.sessionStorage.removeItem(returnStateKey);
        } catch (error) {
            return false;
        }

        return shouldSuppressAnimations;
    }

    function removeEntryAnimationAttributes() {
        var scopes = document.querySelectorAll('[data-music-library-entry-animation-scope]');
        var attributeNames = [
            'data-aos',
            'data-aos-delay',
            'data-aos-duration',
            'data-aos-easing',
            'data-aos-offset',
            'data-aos-anchor',
            'data-aos-anchor-placement',
            'data-aos-once',
            'data-aos-mirror'
        ];

        Array.prototype.forEach.call(scopes, function (scope) {
            var animatedElements = scope.querySelectorAll('[data-aos]');

            Array.prototype.forEach.call(animatedElements, function (element) {
                attributeNames.forEach(function (attributeName) {
                    element.removeAttribute(attributeName);
                });
            });
        });
    }

    document.addEventListener('click', function (event) {
        if (isModifiedNavigation(event) || !getClosestReturnLink(event.target)) {
            return;
        }

        setReturnState();
    });

    if (consumeReturnState()) {
        removeEntryAnimationAttributes();
    }
}(window, document));
